import { render, staticRenderFns } from "./s-intro-big.vue?vue&type=template&id=9fa7bde8&"
import script from "./s-intro-big.vue?vue&type=script&lang=js&"
export * from "./s-intro-big.vue?vue&type=script&lang=js&"
import style0 from "./s-intro-big.vue?vue&type=style&index=0&id=9fa7bde8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports